<button class="button" fxFlex="grow" fxHide fxShow.gt-sm mat-button
        *ngIf="!(authenticationService.user$ | async)?.is_user_available"
        routerLink="/auth/account/beschikbaarheid"
        matTooltip="Je staat als afwezig in het systeem">
  <mat-icon color="warn">event-availability</mat-icon>
</button>
